
import { baseUrl } from "../../../../hooks/useFetch";
import { ApprovalStatus, InductionData, InductionFeedback, InductionStatus, TeamDetails, } from "../Types";

const API_ROOT = `${baseUrl}Induction`;

function getAuthHeaders(): HeadersInit {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  try {
    const raw = sessionStorage.getItem("loginData");
    if (raw) {
      const data = JSON.parse(raw);
      if (data?.token) {
        headers["Authorization"] = `Bearer ${data.token}`;
      }
    }
  } catch (e) {
    // ignore
  }
  return headers;
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const controller = new AbortController();

  const timeout = setTimeout(() => {
    controller.abort();
  }, 20000);

  try {
    const response = await fetch(`${API_ROOT}${path}`, {
      ...init,
      headers: {
        ...getAuthHeaders(),
        ...init?.headers,
      },
      signal: controller.signal,
    });

    if (!response.ok) {
      throw new Error(
        `Induction API failed: ${response.status} ${response.statusText}`
      );
    }

    return await response.json() as T;
  } catch (error) {
    if (error instanceof Error && error.name === "AbortError") {
      throw new Error(`Induction API timeout: ${path}`);
    }

    throw error;
  } finally {
    clearTimeout(timeout);
  }
}



export const inductionService = {
  async getStatus(): Promise<InductionStatus> {
    try {
      return await request<InductionStatus>("/status");
    } catch (err) {
      return { required: false, };
    }
  },

  async getInduction(): Promise<InductionData> {
    const data = await request<InductionData>("/me");
    if (data && data.sections && data.sections.length > 0) {
      return data;
    }
    throw new Error("Unable to retrieve induction configuration from backend");
  },

  async getTeamMembers(teamLeadId?: number, teamLeadName?: string, departmentId?: number): Promise<TeamDetails> {
    try {
      const params = new URLSearchParams();
      if (teamLeadId) params.append("teamLeadId", teamLeadId.toString());
      if (teamLeadName) params.append("teamLeadName", teamLeadName);
      if (departmentId) params.append("departmentId", departmentId.toString());
      return await request<TeamDetails>(`/team-members?${params.toString()}`);
    } catch (err) {
      throw new Error("Unable to retrieve team members from backend");
    }
  },

  async saveProgress(sectionIndex: number): Promise<void> {
    try {
      await request<void>("/progress", {method: "POST",body: JSON.stringify({ sectionIndex }),});
    } catch (err) {
      // Graceful ignore
    }
  },

  async submitFeedback(feedback: InductionFeedback): Promise<void> {
    try {
      await request<void>("/feedback", {method: "POST",body: JSON.stringify(feedback),});
    } catch (err) {
    }
  },

  async complete(): Promise<void> {
    try {
      await request<void>("/complete", { method: "POST" });
    } catch (err) {
    }
  },

  async getApprovalStatus(): Promise<ApprovalStatus> {
    try {
      return await request<ApprovalStatus>("/approval-status");
    } catch (err) {
     throw new Error("Unable to retrieve approval status from backend");
    }
  },
};